"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DatapackModule {
    constructor(title, color, description, version, minecraftVersion, category, namespace, scorespace, authors, dependencies = [], url, manageFunction = ".module/manage", setupFunction = ".module/setup", teardownFunction = ".module/teardown") {
        this.title = title;
        this.color = color;
        this.description = description;
        this.version = version;
        this.minecraftVersion = minecraftVersion;
        this.category = category;
        this.namespace = namespace;
        this.scorespace = scorespace;
        this.authors = authors;
        this.dependencies = dependencies;
        this.url = url;
        this.manageFunction = manageFunction;
        this.setupFunction = setupFunction;
        this.teardownFunction = teardownFunction;
    }
    static fromObject(obj) {
        const dp = new DatapackModule(obj.title, obj.color, obj.description, obj.version, obj.minecraft_version, obj.category, obj.namespace, obj.scorespace, obj.authors, obj.dependencies, obj.url, obj.manage_function, obj.setup_function, obj.teardown_function);
        return dp;
    }
    toObject() {
        return {
            title: this.title,
            color: this.color,
            description: this.description,
            version: this.version,
            minecraft_version: this.minecraftVersion,
            category: this.category,
            namespace: this.namespace,
            scorespace: this.scorespace,
            authors: this.authors,
            dependencies: this.dependencies,
            url: this.url,
            manage_function: this.manageFunction,
            setup_function: this.setupFunction,
            teardown_function: this.teardownFunction
        };
    }
}
exports.DatapackModule = DatapackModule;
//# sourceMappingURL=datapack-module.js.map